import '../../styles/SearchPopup.css';

import { FC, memo, useCallback, useEffect } from 'react';
import {
  DataGridPremium,
  GridRenderCellParams,
  GridRowId,
  useGridApiRef,
} from '@mui/x-data-grid-premium';
import moment from 'moment';
import { getConfig } from '../../utility_objects/WhiteCache';
import { useSearch } from 'packages/blu-booking/src/data_fetching/Search';

interface DisplayResultsInterface {
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action?: (value: any) => void;
  unregistered: boolean;
  keyDown?: string;
  setKeyDown?: (value: string) => void;
  enterAction?: (value: any) => void;
}

export const DisplayResults: FC<DisplayResultsInterface> = memo(
  ({
    value,
    action = () => null,
    unregistered,
    enterAction,
    keyDown,

    setKeyDown,
  }) => {
    const { focus10 } = getConfig();
    const { data, isLoading } = useSearch(
      value,
      unregistered,
      focus10 && !unregistered ? '100' : '5'
    );

    const today = moment();
    const apiRef = useGridApiRef();

    useEffect(() => {
      if (data && data.length > 0) {
        const selectedRowIds = Array.from(
          apiRef.current.getSelectedRows().keys()
        );
        const selectedRowId = selectedRowIds[0];

        const currentRowIndex = data.findIndex(
          (row) => row?.id === selectedRowId
        );
        if (currentRowIndex === -1) {
          apiRef.current.selectRow(data[0]?.id);
          apiRef.current.setSelectionModel([data[0]?.id]);
        }
      }
    }, [apiRef, data]);

    const gestioneSelezioneArrows = useCallback(
      (id: GridRowId, next: boolean) => {
        if (data) {
          if (next) {
            const currentRowIndex = data.findIndex((row) => row?.id === id);

            if (currentRowIndex < data.length - 1) {
              const newSelectedRowId = data[currentRowIndex + 1]?.id;

              apiRef.current.selectRow(newSelectedRowId);
              apiRef.current.setSelectionModel([newSelectedRowId]);
            }
          } else {
            const currentRowIndex = data.findIndex((row) => row?.id === id);
            if (currentRowIndex > 0) {
              const newSelectedRowId = data[currentRowIndex - 1]?.id;
              apiRef.current.selectRow(newSelectedRowId);
              apiRef.current.setSelectionModel([newSelectedRowId]);
            }
          }
        }
      },
      [apiRef, data]
    );

    useEffect(() => {
      if (keyDown) {
        const selectedRowIds = Array.from(
          apiRef.current.getSelectedRows().keys()
        );
        const selectedRowId = selectedRowIds[0];

        if (keyDown === 'Enter') {
          const selectedRow = apiRef.current.getRow(selectedRowId);
          if (selectedRow) enterAction(selectedRow);
        } else if (keyDown === 'ArrowUp') {
          gestioneSelezioneArrows(selectedRowId, false);
          // Handle arrow up key press
        } else if (keyDown === 'ArrowDown') {
          // Handle arrow down key press
          gestioneSelezioneArrows(selectedRowId, true);
        }
        setKeyDown(undefined);
      }
    }, [apiRef, enterAction, gestioneSelezioneArrows, keyDown, setKeyDown]);

    //"1995-11-21T00:00:00"

    return (
      <DataGridPremium
        columns={[
          {
            field: 'id',
            hide: true,
          },
          {
            field: 'surname',
            headerName: 'Cognome',
            flex: 1,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'cognome2',
            headerName: 'Cognome 2',
            width: 130,
            editable: false,
            hide: !focus10 || unregistered,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'dataNascita',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Età',
            width: 60,
            editable: false,
            hide: !focus10 || unregistered,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams) => {
              const dataNString = params.value;
              if (dataNString) {
                const dataN = moment(dataNString);
                const eta = today.diff(dataN, 'years');
                return eta;
              }

              return '';
            },
          },
          {
            field: 'indirizzo',
            headerName: 'Indirizzo',
            flex: 1,
            editable: false,
            hide: !focus10 || unregistered,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'citta',
            headerName: 'Città',
            flex: 1,
            editable: false,
            hide: !focus10 || unregistered,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'email',
            headerName: 'Email',
            flex: 1,
            editable: false,
            hide: focus10 && !unregistered,
            sortable: false,
            disableColumnMenu: true,
          },
          {
            field: 'telephone',
            headerName: 'Telefono',
            flex: 1,
            editable: false,
            hide: focus10 && !unregistered,
            sortable: false,
            disableColumnMenu: true,
          },
        ]}
        rows={data ? data : []}
        apiRef={apiRef}
        sx={{
          height: '290.5px',
          '& .MuiDataGrid-row': {
            cursor: 'pointer',
            minHeight: '50px !important',
          },
        }}
        loading={isLoading && data === undefined}
        density="compact"
        disableColumnMenu
        hideFooter
        disableMultipleSelection
        editMode="row"
        getRowHeight={() => 'auto'}
        onProcessRowUpdateError={(error) => console.log(error)}
        experimentalFeatures={{ newEditingApi: true }}
        onRowClick={(event: any) => {
          action(event?.row);
        }}
      />
    );
  }
);
